import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'

export interface OnboardingStateModel {
  customFilterHintDismissed: boolean
}

const defaults: OnboardingStateModel = {
  customFilterHintDismissed: false,
}

export class OnboardingDismissCustomFilterHint {
  static readonly type = '[Onboarding] Dismiss Custom Filter Hint'
}

@Injectable()
@State<OnboardingStateModel>({
  name: 'onboarding',
  defaults,
})
export class OnboardingState {
  @Selector()
  static isCustomFilterHintDismissed(state: OnboardingStateModel): boolean {
    return state.customFilterHintDismissed
  }

  @Action(OnboardingDismissCustomFilterHint)
  dismissCustomFilterHint(ctx: StateContext<OnboardingStateModel>): void {
    ctx.patchState({ customFilterHintDismissed: true })
  }
}
